import { ControlledSelectField } from 'components/Form';
import type { ActKc2StatusEnum } from 'gql/graphql';
import { getActKC2StatusLabel } from 'pages/Project/Common/types';

import { useMemo } from 'react';
import type { UseControllerProps } from 'react-hook-form';

export const ActKC2StatusField = ({
    name,
    control,
    defaultValue,
    isCreating,
    disabled,
    statusFollowers,
}: UseControllerProps & { isCreating: boolean; disabled: boolean; statusFollowers?: ActKc2StatusEnum[] | null }) => {
    const statusItems = useMemo(() => {
        const followers = (statusFollowers || []).map((v) => ({
            id: v,
            label: getActKC2StatusLabel(v),
        }));

        return [...followers, ...(defaultValue ? [defaultValue] : [])];
    }, [defaultValue, statusFollowers]);

    return (
        <ControlledSelectField
            name={name}
            label="Статус"
            control={control}
            items={statusItems}
            disabled={isCreating || disabled}
        />
    );
};

ActKC2StatusField.displayName = 'ActKC2StatusField';
